import { Box, Collapse, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React, { Fragment } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { useAppStore } from '../../../store/appStore.tsx';

const ReadOnlyRowUsuario = ({ row, setOpenDialog, setOpenAddEditDialog, setIsUpdate, setDeleteRow, selectedRow, setSelectedRow }) => {
    const [open, setOpen] = React.useState(false);
    const { currentUser } = useAppStore(appStore => appStore);

    const handleDeleteClick = (event, row) => {
        event.stopPropagation();
        setDeleteRow(row);
        setOpenDialog(true);
    }

    const handleEditClick = (event, row) => {
        event.stopPropagation();
        setIsUpdate(true);
        setSelectedRow(row);
        setOpenAddEditDialog(true);
    }

    // Lógica para detectar clic simple (seleccionar) o doble clic (editar)
    const handleRowClick = (event) => {
        switch (event.detail) {
            case 1:
                setSelectedRow(row);
                break;
            case 2: // Doble clic
                setSelectedRow(row);
                if (currentUser?.tipoUsuario === 'superusuario' || currentUser?.tipoUsuario === 'administrador') {
                    setIsUpdate(true);
                    setOpenAddEditDialog(true);
                }
                break;
            default:
                break;
        }
    }

    return (
        <Fragment>
            <TableRow onClick={handleRowClick}
                sx={{
                    backgroundColor: selectedRow?.id === row.id ? '#F0F0F0' : 'white',
                    cursor: 'pointer'
                }}>
                <TableCell>
                    <IconButton size="small" onClick={(e) => { e.stopPropagation(); setOpen(!open); }}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell align='left'>{row.id}</TableCell>
                <TableCell align='left'>{row.name}</TableCell>
                <TableCell align='left'>{row.email}</TableCell>
                <TableCell align='center' sx={{ textTransform: 'capitalize' }}>{row.tipoUsuario}</TableCell>
                
                <TableCell align='left'>
                    <Stack direction='row' spacing={0}>
                        {(currentUser?.tipoUsuario === 'superusuario' || currentUser?.tipoUsuario === 'administrador') &&
                            <>
                                <IconButton color="primary" onClick={(e) => handleEditClick(e, row)}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton sx={{ color: 'red' }} onClick={(e) => handleDeleteClick(e, row)}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </>
                        }
                    </Stack>
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 2, paddingBottom: 3, bgcolor: '#F7F7F7' }}>
                            <Typography variant="h6" gutterBottom component="div">
                                Detalles de Seguridad
                            </Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Contraseña Provisional Asignada</TableCell>
                                        <TableCell>Inicio de sesión con Google</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>{row.mustChangePassword ? "Sí (Pendiente de cambio)" : "No"}</TableCell>
                                        <TableCell>{row.google ? "Sí" : "No"}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    )
}
export default ReadOnlyRowUsuario;